const styles = {
  container: {
    fontFamily: "Inter Tight",
  },
  header: {
    padding: "4vh 2vw 2vh",
    background:
      "linear-gradient(180deg, rgba(255, 162, 162, 0.30) 0%, rgba(255, 255, 255, 0.00) 100%)",
  },
  headerContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "30px",
  },
  idText: {
    fontSize: "12px",
    color: "#0D0D0E",
  },
  idLabel: {
    color: "#949DAA",
    fontSize: "14px",
  },
  statusContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  statusCircle: {
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    border: "5px solid #fff",
  },
  milestoneStatusCircle: {
    width: "15px",
    height: "15px",
    borderRadius: "50%",
    border: "3px solid rgb(229, 229, 229)",
  },
  statusText: {
    fontSize: "14px",
    color: "#0D0D0E",
  },
  subContainer: {
    padding: "2vh 2vw",
  },
  startDate: {
    fontSize: "14px",
    color: "#0D0D0E",
  },
  endDate: {
    fontSize: "14px",
    color: "#949DAA",
  },
  projectHeading: {
    color: "#0D0D0E",
    fontSize: "22px",
    fontWeight: "500",
  },
  rowFlex: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  columnFlex: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  price: {
    color: "#0D0D0E",
    fontSize: "18px",
    fontWeight: "500",
  },
  greyRow: {
    color: "#949DAA",
    marginBottom: "2px",
    fontWeight: "500",
  },
  milestoneBtn: {
    borderRadius: "4px",
    background: "#4D6BF6",
    padding: ".7vh .7vw",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  },
  //Project Overview
  overview_section: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    marginTop: "2vh",
    gap: "50px",
  },
  section_1: {
    flex: 2,
  },
  section_2: {
    flex: 1,
  },
  section_heading: {
    color: "#0D0D0E",
    fontSize: "18px",
    fontWeight: "500",
  },
  section_sub_heading: {
    color: "#949DAA",
    fontSize: "14px",
    fontWeight: "500",
  },
  name: {
    color: "#0D0D0E",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontsize: "14px",
    fontWeight: 600,
  },
  location: {
    borderRadius: "12px",
    background: "#F7F7F7",
    padding: "1vh 1vw",
  },
  stats_section: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    boxShadow: "none",
    borderRadius: 0,
    borderBottom: "1px solid #D7D8D9",
    paddingBottom: 0,
    alignItems: "flex-end",
  },
  stats_label: {
    marginBottom: "1vh",
    letterSpacing: "0",
    fontSize: "16px",
    color: "#949DAA",
  },
  stats_value: {
    fontSize: "20px",
    color: "#0D0D0E",
    fontWeight: "500",
  },
  //budgetitem
  budget_item_heading: {
    color: "#0D0D0E",
    fontSize: "18px",
    fontWeight: "500",
    textTransform: "capitalize",
  },
  budget_item_text: {
    color: "#949DAA",
    fontSize: "14px",
    fontWeight: "500",
  },
  budget_item_amount_div: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "18px",
    color: "#0D0D0E",
    marginTop: "1vh",
  },
  modal_heading: {
    color: " #0D0D0E",
    fontSize: "20px",
    fontWeight: "500",
  },
  modal_desc: {
    color: "#949DAA",
    fontSize: "14px",
    fontWeight: "500",
  },
  modal_value: {
    color: "#0D0D0E",
    fontSize: "14px",
    fontWeight: "600",
  },
  status_pill: {
    borderRadius: "34px",
    padding: "4px 8px",
    fontSize: "14px",
    minWidth: "7ch",
    width: "fit-content",
    border: "none",
    textAlign: "center",
  },
  projectHeading: {
    color: "#0D0D0E",
    fontSize: "20px",
    fontWeight: "500",
  },
};

export default styles;
